(function () {
  if (
    // window.location.search?.includes("variant=") ||
    window.location.search?.includes("sortBy=")
  ) {
    document.querySelector("[name='robots']")?.remove();
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if ((links[i].href.indexOf('products') !== -1 && links[i].href.indexOf('variant') !== -1) || (links[i].href.indexOf('collections') !== -1 && links[i].href.indexOf('+') !== -1)) {
      links[i].rel = 'nofollow';
    }
  }
});